const RenderSurveyQuestions = ({
  set_answers,
  answers,
  numberOptions,
  questions,
  unanswered = [],
  optionLabels,
}) => {
  const setQuestion = (answer) => {
    set_answers({ ...answers, [answer.num]: answer });
  };

  const unansweredSet = new Set(unanswered.map(Number));
  const lowLabel = optionLabels?.low;
  const highLabel = optionLabels?.high;

  return (
    <div className="survey-questions">
      {(lowLabel || highLabel) && (
        <div className="scale-hint" aria-hidden="true">
          <span>{lowLabel}</span>
          <span className="scale-hint__arrow" />
          <span>{highLabel}</span>
        </div>
      )}

      {questions.map((question) => {
        const selected = answers[question.num]?.grade;
        const isMissing = unansweredSet.has(question.num);

        return (
          <div key={question.num}>
            {question.sec && <h3 className="survey-section-title">{question.sec}</h3>}
            <div
              className={`survey-question${isMissing ? ' is-missing' : ''}${
                selected != null ? ' is-answered' : ''
              }`}
              id={`survey-q-${question.num}`}
            >
              <p className="survey-question__text">
                <span className="survey-question__num">{question.num}</span>
                {question.question}
              </p>
              <div
                className="survey-question__options"
                role="radiogroup"
                aria-label={`Pregunta ${question.num}`}
              >
                {numberOptions.map((number) => {
                  const isSelected = selected === number;
                  return (
                    <button
                      key={number}
                      type="button"
                      role="radio"
                      aria-checked={isSelected}
                      className={`rating-pill${isSelected ? ' is-selected' : ''}`}
                      onClick={() =>
                        setQuestion({
                          letter: question.letter,
                          grade: number,
                          num: question.num,
                        })
                      }
                    >
                      {number}
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default RenderSurveyQuestions;
